document.addEventListener('DOMContentLoaded', () => {
  const productForm = document.querySelector('[data-selects]');
  if (!productForm) return;

  const productType = productForm.dataset.productType;
  const productTitleElement = document.querySelector('h1');

  // Check if any variant selection title contains "Size" and "UK"
  const variantTitles = productForm.querySelectorAll('.product__variant-label-box');
  
  const hasSizeUKOption = Array.from(variantTitles).some(title => {
    const titleText = title.textContent;
    return titleText && 
           titleText.toLowerCase().includes('size') && 
           titleText.toLowerCase().includes('uk');
  });

  const shouldRun = productType === 'footwear' ||
    (productTitleElement && productTitleElement.textContent.toLowerCase().includes('boots')) ||
    productForm.querySelector('[data-original-size]') ||
    hasSizeUKOption;

  if (!shouldRun) return;

  const sizeChartScript = document.getElementById('size-conversions-json');
  if (!sizeChartScript) {
    console.error("Missing required elements for size conversion script.");
    return;
  }

  const productTitle = productTitleElement.textContent.toLowerCase();

  const sizeCharts = JSON.parse(sizeChartScript.textContent);

  let selectedGender = 'men';
  if (productTitle.includes('unisex')) {
    selectedGender = 'unisex';
  } else if (productTitle.includes('women')) {
    selectedGender = 'women';
  } else if (productTitle.includes('kids first')) {
    selectedGender = 'kids first';
  } else if (productTitle.includes('junior')) {
    selectedGender = 'junior';
  }

  // A single function to update all size elements
  function updateElementSizes(elements, type) {
    elements.forEach(element => {
      const originalUKSize = element.dataset.originalSize;
      const conversionData = sizeCharts[selectedGender]?.[originalUKSize];
      
      const sizeSpan = element.querySelector('.variant-size-text');
      const convertedDiv = element.querySelector('.converted-size-text');

      // Only show size conversion if hasSizeUKOption is true
      if (hasSizeUKOption) {
        if (sizeSpan && !isNaN(parseFloat(originalUKSize)) && !sizeSpan.textContent.includes('UK')) {
          sizeSpan.textContent = `UK ${originalUKSize}`;
        }

        if (convertedDiv) {
          convertedDiv.textContent = conversionData ? conversionData.us : '';
        }
      } else {
        // Clear converted size text if condition is not met
        if (convertedDiv) {
          convertedDiv.textContent = '';
        }
      }
    });
  }

  // Update sizes for all variant types on page load
  updateElementSizes(productForm.querySelectorAll('.variant-selector-label'), 'pills');
  updateElementSizes(productForm.querySelectorAll('.select-option'), 'dropdown');

  // Find the selected option and update the main custom select button
  const customSelects = document.querySelectorAll('.custom-select');
  customSelects.forEach(select => {
    const selectedOption = select.querySelector('[aria-selected="true"]');
    if (selectedOption) {
      const mainSizeSpan = select.querySelector('.selected-option');
      const mainConvertedSpan = select.querySelector('.selected-converted-size');
      const optionSizeSpan = selectedOption.querySelector('.variant-size-text');
      const optionConvertedDiv = selectedOption.querySelector('.converted-size-text');

      if (mainSizeSpan) {
        mainSizeSpan.textContent = optionSizeSpan?.textContent || '';
      }
      if (mainConvertedSpan && hasSizeUKOption) {
        mainConvertedSpan.textContent = optionConvertedDiv?.textContent ? `(${optionConvertedDiv.textContent})` : '';
      }
    }
  });
});

// Helper function remains outside the DOMContentLoaded listener
function updateVariantSelection(productForm, selectedOptions) {
  if (!productForm) return;

  const variantIdInput = document.querySelector(`input[name="id"][form="${productForm.dataset.formId}"]`);
  if (!variantIdInput) return;

  const variantsJson = productForm.querySelector('script[type="application/json"]');
  if (!variantsJson) return;

  try {
    const variants = JSON.parse(variantsJson.textContent);
    const matchingVariant = variants.find(variant =>
      variant.options.every((option, index) => option === selectedOptions[index])
    );

    if (matchingVariant) {
      variantIdInput.value = matchingVariant.id;
    }
  } catch (error) {
    console.error('Error updating variant selection:', error);
  }
}

// CustomSelect class remains the same
class CustomSelect {
  constructor(element) {
    if (!element) return;
    
    this.element = element;
    this.button = element.querySelector('[data-select-button]');
    this.dropdown = element.querySelector('[data-select-dropdown]');
    this.select = element.querySelector('select');
    this.options = element.querySelectorAll('.select-option');
    this.productForm = element.closest('[data-selects]');
    
    // Store the main button display elements
    this.selectedOptionSpan = this.element.querySelector('.selected-option');
    this.convertedSizeSpan = this.element.querySelector('.selected-converted-size');

    if (!this.button || !this.dropdown || !this.select || !this.selectedOptionSpan) {
      console.warn('CustomSelect: Required elements missing');
      return;
    }
    
    this.isOpen = false;
    this.init();
  }

  init() {
    this.button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.toggleDropdown();
    });
    
    this.options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (option.getAttribute('aria-disabled') !== 'true') {
          this.selectOption(option);
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (!this.element.contains(e.target)) {
        this.closeDropdown();
      }
    });

    this.button.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.toggleDropdown();
      } else if (e.key === 'Escape') {
        this.closeDropdown();
      }
    });

    this.updateSelectedOption();
  }

  toggleDropdown() {
    this.isOpen ? this.closeDropdown() : this.openDropdown();
  }

  openDropdown() {
    this.isOpen = true;
    this.button.setAttribute('aria-expanded', 'true');
    this.dropdown.classList.remove('hidden');
  }

  closeDropdown() {
    this.isOpen = false;
    this.button.setAttribute('aria-expanded', 'false');
    this.dropdown.classList.add('hidden');
  }

  selectOption(option) {
    const value = option.dataset.value;
    
    this.select.value = value;
    
    this.updateSelectedOption(option);
    
    this.updateVariantSelection();
    
    this.closeDropdown();
  }

  updateSelectedOption(option = null) {
    this.options.forEach(opt => {
      opt.setAttribute('aria-selected', 'false');
      opt.classList.remove('bg-gray-50');
    });

    if (option) {
      option.setAttribute('aria-selected', 'true');
      option.classList.add('bg-gray-50');
      
      const sizeSpan = option.querySelector('.variant-size-text');
      const convertedDiv = option.querySelector('.converted-size-text');
      
      this.selectedOptionSpan.textContent = sizeSpan?.textContent || '';
      
      // Check if variant selection title contains both "Size" and "UK"
      const variantTitles = this.productForm.querySelectorAll('.product__variant-label-box');
      const hasSizeUKOption = Array.from(variantTitles).some(title => {
        const titleText = title.textContent;
        return titleText && 
               titleText.toLowerCase().includes('size') && 
               titleText.toLowerCase().includes('uk');
      });
      
      if (this.convertedSizeSpan) {
        if (hasSizeUKOption) {
          this.convertedSizeSpan.textContent = convertedDiv?.textContent ? `(${convertedDiv.textContent})` : '';
        } else {
          this.convertedSizeSpan.textContent = '';
        }
      }
    }
  }

  updateVariantSelection() {
    if (!this.productForm) return;
    const selects = this.productForm.querySelectorAll('select[data-index]');
    const selectedOptions = Array.from(selects).map(select => select.value);
    updateVariantSelection(this.productForm, selectedOptions);
  }
}

// Final event listener for initialization
document.addEventListener('DOMContentLoaded', () => {
  const customSelects = document.querySelectorAll('.custom-select');
  customSelects.forEach(select => new CustomSelect(select));
  
  const productForms = document.querySelectorAll('[data-selects]');
  productForms.forEach(form => {
    const radioGroups = form.querySelectorAll('[data-option-type="radio"]');
    
    radioGroups.forEach(group => {
      const radioInputs = group.querySelectorAll('input[type="radio"]');
      
      radioInputs.forEach(radio => {
        radio.addEventListener('change', () => {
          const allOptions = Array.from(form.querySelectorAll('[data-option-type]'))
            .sort((a, b) => parseInt(a.dataset.index?.replace('option', '') || 0) - parseInt(b.dataset.index?.replace('option', '') || 0))
            .map(el => {
                const checkedRadio = el.querySelector('input[type="radio"]:checked');
                return checkedRadio ? checkedRadio.value : el.querySelector('select')?.value;
            });
          updateVariantSelection(form, allOptions.filter(Boolean));
        });
      });
    });
  });
});